import * as types from './types'

export function initEmployees() {
    return dispatch => {
        return fetch(process.env.REACT_APP_APIHOST + '/wp-json/wp/v2/employee?per_page=50&_embed=1&orderby=menu_order&order=asc')
            .then(response => response.json())
            .then(json => dispatch(receiveEmployees(json)));
    }
}

function receiveEmployees(json) {
    return {
        type: types.FETCH_EMPLOYEES_SUCCESS,
        employees: json
    }
}


// WEBPACK FOOTER //
// ./src/actions/employeesActions.js